import type { SettingsTab } from "@ext/catalog/actions/propsEditor/components/Sections";
import { useCallback, useEffect, useRef, useState } from "react";
import type { FieldErrors } from "react-hook-form";
import type { FormData } from "./createFormSchema";

const FIELD_TABS: Record<keyof FormData, SettingsTab> = {
	title: "general",
	url: "storage",
	docroot: "storage",
	language: "language",
	versions: "language",
	description: "general",
	style: "general",
	code: "general",
	logo: "general",
	syntax: "advanced",
	icons: "icons",
	lfs: "lfs",
};

const FIELD_ORDER = Object.keys(FIELD_TABS) as (keyof FormData)[];

export const useRevealInvalidField = (onActiveTabChange: (tab: SettingsTab) => void) => {
	const formRef = useRef<HTMLFormElement>(null);
	const [isRevealing, setIsRevealing] = useState(false);

	useEffect(() => {
		if (!isRevealing) return;
		formRef.current?.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus();
		setIsRevealing(false);
	}, [isRevealing]);

	const revealInvalidField = useCallback(
		(errors: FieldErrors<FormData>) => {
			const field = FIELD_ORDER.find((name) => errors[name]);
			if (!field) return;
			onActiveTabChange(FIELD_TABS[field]);
			setIsRevealing(true);
		},
		[onActiveTabChange],
	);

	return { formRef, revealInvalidField };
};
